require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-conrad-residence-thelocalproject.json") })
        }
      }, "path---journal-conrad-residence-thelocalproject");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-conrad-residence-thelocalproject!./.cache/json/journal-conrad-residence-thelocalproject.json
// module id = 469
// module chunks = 231608221292675